import { render } from "./TaskManagementVideo.vue?vue&type=template&id=111786b9&scoped=true"
import script from "./TaskManagementVideo.vue?vue&type=script&lang=ts"
export * from "./TaskManagementVideo.vue?vue&type=script&lang=ts"

import "./TaskManagementVideo.vue?vue&type=style&index=0&id=111786b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-111786b9"

export default script